/**
 * @file wsgenv
 * @refs http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=692904891
 * @note 有几个坑，
 *      1. wsg初始化并没有回调，直接调用wsgParams有可能会拿到空值
 *      2. wsgsdk本身体积很大，因为这个原因又不得不提前初始化
 */
import * as WSGLib from '@didi/wsgsdk'
import { Tracker } from '@/utils/event-lib'
import { getStore, setStore } from '@/store/store-standard'

const NEXT_TIMEOUT = 2000

let cached = false
/**
 * 1. 如果设备指纹未初始化成功，则将回调加入队列
 * 2. 如果设备指纹初始化成功，则检查是否有uid
 * 3. 如果都具备，但设备指纹获取为空，则再延迟2s获取。
 */
const initSDK = (uid = '') => {
  // 保证只初始化一次
  if (cached) {
    return Promise.resolve()
  }
  return new Promise<void>((resolve) => {
    WSGLib.initSDK({
      appId: '06040702',
      env: 'AME',
      uid,
      wsgenvEnv: 'single',
      isGetGeo: false,
    })
    setTimeout(() => {
      cached = true
      resolve()
    }, NEXT_TIMEOUT)
  })
}

const fallback = (
  cb: (fingerPrints: string) => void,
  uid: string
) =>
  initSDK(uid)
    .then(() => {
      const url =
        'https://manhattan-app.didiglobal.com/freya/landing-page'
      return new Promise((resolve) =>
        setTimeout(
          () => WSGLib.wsgParams({ url }, resolve),
          0
        )
      )
    })
    .then((value: any) => {
      // 如果value为空，则初始化失败，在2s后二次上报
      if (value === '') {
        Tracker.trackWithRaven('FN:wsgenv-lib', {
          msg: 'call once more',
        })
        return setTimeout(
          () => fallback(cb, uid),
          NEXT_TIMEOUT
        )
      }
      cb(value)
    })

let isReady = false
const fallbacks = [] as (() => unknown)[]
export const WSG = {
  init: () => {
    const uid = getStore('user')?.uid
    fallback((value) =>
      // wsgenv 收集
      {
        setStore('wsgenv', value)
        isReady = true
        while (fallbacks.length) {
          const cb = fallbacks.shift()
          cb && cb()
        }
      }, uid)
  },

  // wsg-env ready后执行
  ready(cb: () => unknown) {
    if (isReady) {
      return cb()
    }
    fallbacks.push(cb)
  },
  // wsg-env ready后执行，promisify
  readyPromisify(cb?: () => unknown) {
    return new Promise((resolve) => {
      this.ready(() => {
        cb && cb()
        resolve(void 0)
      })
    })
  },
}
